import { cn } from '@/lib/utils';
import type { ModalTema } from './types';

interface SectionHeadingProps {
  num: number;
  title: string;
  tema: ModalTema;
  // Conteúdo à direita do título: cadeado + "tabela do plano" (Padrão) ou pílula EDITÁVEL (Enterprise).
  trailing?: React.ReactNode;
}

// Cabeçalho de seção do drawer (①/②/③): badge numerado em círculo — azul no modo
// Padrão, verde no Enterprise (número escuro p/ contraste sobre o pistache).
export function SectionHeading({ num, title, tema, trailing }: SectionHeadingProps) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <span
        className={cn(
          'flex size-5 shrink-0 items-center justify-center rounded-full text-[11px] font-bold tabular-nums',
          tema === 'verde' ? 'bg-tertiary text-on-tertiary' : 'bg-primary text-white'
        )}
      >
        {num}
      </span>
      <h3 className="text-sm font-semibold text-text-title">{title}</h3>
      {trailing}
    </div>
  );
}
